<template>
  <div class="page-wrap p-3">
    <div class="mt-3 mb-3">
      <a :href="`/dict/edu-areas`">
        <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
        Назад
      </a>
    </div>

    <div class="page-header p-3 mb-3 mt-3">
      <h3>Редактирование область образование</h3>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="code" class="form-label col-md-4">
            Код
          </label>
          <div class="col-md-8">
            <input class="form-control" id="code" type="text"
                   :disabled="true"
                   v-model="eduArea.code">
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="name" class="form-label col-md-4">
            Наименование
          </label>
          <div class="col-md-8">
            <input class="form-control" id="name" type="text" v-model="eduArea.nameRu">
          </div>
        </div>
      </div>
    </div>


  </div>
  <div class="page-footer justify-content-end"  v-if="isAdmin()">
    <b-button variant="success" @click="onClickSave()">
      Сохранить
    </b-button>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import professionEduAreaService from "@/services/professionEduAreaService";

export default {
  components: {
    VueLoading
  },
  computed: {
    eduAreaUuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      eduArea: {
        id: {
          code: null
        },
        nameRu: null
      }
    };
  },
  methods: {
    init() {
      this.findById(this.eduAreaUuid);
    },


    async findById(uuid) {
      this.isLoading = true;
      this.eduArea = await professionEduAreaService.findByUuid(uuid);
      this.isLoading = false;
    },
    async onClickSave() {
      try {
        this.isLoading = true;
        this.eduArea = await professionEduAreaService.save(this.eduArea);
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    isAdmin() {
      return delegationService.isAdmin();
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}
</style>
